import Vue from 'vue';
import VueRouter from 'vue-router';

import forumRoutes from './forom';

Vue.use(VueRouter);

const routes = [
	{
		path: '/forum',
		component: () => import(/* webpackChunkName: "forum" */'@/views/forum/Main.vue'),
		children: [
			...forumRoutes
		]
	},
	{
		path: '/auth/reset_password/:hash',
		name: 'reset_password',
		component: () => import('../views/ResetPassword.vue'),
		meta: {
			title: 'Reset Password',
			layout: 'auth',
		},
	},

	{
		path: '/auth/onboarding/setup',
		name: 'setup',
		component: () => import('../views/ProgramSelection.vue'),
		meta: {
			title: 'On Boarding',
			layout: 'auth',
		},
	},

	{
		path: '/cards_admin',
		name: 'cards_admin',
		component: () => import(/* webpackChunkName: "admin" */'../views/CardsAdmin.vue'),
		meta: {
			title: 'Cards',
			min_level: 'admin',
		},
	},

	{
		path: '/faq',
		name: 'faq',
		component: () => import('../views/Faq.vue'),
		meta: {
			title: 'FAQ',
			min_level: 'member',
		},
	},

	{
		path: '/faq_admin',
		name: 'faq_admin',
		component: () => import(/* webpackChunkName: "admin" */'../views/FaqAdmin.vue'),
		meta: {
			title: 'FAQ',
			min_level: 'admin',
		},
	},

	{
		path: '/',
		alias: '/dashboard',
		name: 'home',
		component: () => import('../views/Dashboard.vue'),
		meta: {
			title: 'My Dashboard',
			min_level: 'member',
		},
	},
	// {
	// 	path: '/dashboard/:user_id',
	// 	name: 'dashboard',
	// 	component: () => import('../views/Dashboard.vue'),
	// 	meta: {
	// 		title: 'Member Dashboard',
	// 		min_level: 'member',
	// 	},
	// },

	{
		path: '/databaseDL/:token',
		name: 'databaseDL',
		meta: {
			title: 'DBDL',
			min_level: 'admin',
		},
		beforeEnter(uri) {
			console.log(uri.params.token);
			window.open('https://api.iamconnected.com/databaseDL?token=' + uri.params.token, '_blank');
		},
	},
	{
		path: '/charts/:metrics/:user_id',
		name: 'charts',
		component: () => import('../views/ChartsData.vue'),
		meta: {
			title: 'Chart Data',
			min_level: 'member',
		},
	},
	{
		path: '/bioTesting/quizzes_submitted',
		name: 'BioTestingQuizDashboard',
		component: () => import(/* webpackChunkName: "bio-testing" */'../views/BioTestingQuizDashboard.vue'),
		meta: {
			title: 'BioTesting - Submitted Quizzes',
			min_level: 'editor',
		},
	},
	{
		path: '/bioTesting/quizzes/create',
		name: 'bioTestingCreateQuiz',
		component: () => import(/* webpackChunkName: "bio-testing" */'../views/BioTestingCreateQuiz.vue'),
		meta: {
			title: 'BioTesting Create/Edit Quiz',
			min_level: 'editor',
		},
	},
	{
		path: '/bioTesting/quizzes/edit',
		name: 'bioTestingCreateQuizList',
		component: () => import(/* webpackChunkName: "bio-testing" */'../views/BioTestingCreateQuiz.vue'),
		meta: {
			title: 'BioTesting Quizzes',
			min_level: 'editor',
		},
	},
	{
		path: '/bioTesting/quizzes/edit/:quiz_id',
		name: 'bioTestingCreateQuizEdit',
		component: () => import(/* webpackChunkName: "bio-testing" */'../views/BioTestingCreateQuiz.vue'),
		meta: {
			title: 'BioTesting Edit Quiz',
			min_level: 'editor',
		},
	},
	{
		path: '/bioTesting/quiz_result/:result_id',
		name: 'BioTestingQuizResults',
		component: () => import(/* webpackChunkName: "bio-testing" */'../views/BioTestingQuizResults.vue'),
		meta: {
			title: 'BioTesting Quiz Results',
			min_level: 'editor',
		},
	},
	{
		path: '/bioTesting/takeQuiz/:quiz_id',
		name: 'BioTestingTakeQuiz',
		component: () => import(/* webpackChunkName: "bio-testing" */'../views/BioTestingTakeQuiz.vue'),
		meta: {
			title: 'BioTesting Take Quiz',
			min_level: 'member',
		},
	},
	{
		path: '/course/:id',
		name: 'course',
		component: () => import('../views/Courses.vue'),
		meta: {
			title: 'Course',
		},
	},
	{
		path: '/courses_admin',
		name: 'courses_admin',
		component: () => import(/* webpackChunkName: "admin" */'../views/CoursesAdmin.vue'),
		meta: {
			title: 'Courses Admin',
			min_level: 'admin',
		},
	},
	{
		path: '/course_sections/:id',
		name: 'course_sections',
		component: () => import(/* webpackChunkName: "admin" */'../views/CoursesSectionAdmin.vue'),
		meta: {
			title: 'Course Section Admin',
			min_level: 'admin',
		},
	},
	{
		path: '/course_subsections/:id',
		name: 'course_subsections',
		component: () => import(/* webpackChunkName: "admin" */'../views/CoursesSubsectionAdmin.vue'),
		meta: {
			title: 'Course Subsection Admin',
			min_level: 'admin',
		},
	},
	{
		path: '/dreams_log/:user_id',
		name: 'dreams_log',
		component: () => import('../views/Dreams.vue'),
		meta: {
			title: 'Dreams Log',
			min_level: 'member',
		},
	},
	{
		path: '/reflections/:user_id?/:id?',
		name: 'reflections',
		component: () => import('../views/Feelings.vue'),
		meta: {
			title: 'Reflections',
			min_level: 'member',
		},
	},
	{
		path: '/feelings_log/:user_id',
		redirect: to => ({ path: '/reflections/' + to.params.user_id, query: to.query }),
	},
	{
		path: '/meditation_dashboard',
		name: 'meditation_dashboard',
		component: () => import('../views/CategoryDashboard.vue'),
		meta: {
			title: 'Meditation',
			category: 'meditation',
			dash_type: 'category',
			showShortcuts: false,
		},
	},
	{
		path:'/coaches_dashboard',
		name:'Coaches',
		component: () => import(/* webpackChunkName: "coaches" */'../views/coaches_dashboard.vue'),
		meta:{
			title:'Coaches',
			category:'Coaches',
			dash_type:'Coaches',
		}

	},
	{
		path: '/contractions',
		name: 'headling_dashboard',
		component: () => import(/* webpackChunkName: "healing" */'../views/Healing.vue'),
		meta: {
			title: 'Healing Dashboard',
			category: 'healing',
			dash_type: 'category',
		},
	},
	{
		path: '/sleep_dashboard',
		name: 'sleep_dashboard',
		component: () => import('../views/CategoryDashboard.vue'),
		meta: {
			title: 'Sleep Dashboard',
			category: 'sleep',
			dash_type: 'category',
		},
	},
	{
		path: '/payments/manage_billing',
		name: 'manage_billing',
	},
	{
		path: '/payments/subscriptions/:page_type',
		name: 'subscriptions_action',
		component: () => import(/* webpackChunkName: "payment" */'../views/SubscriptionOverview.vue'),
		meta: {
			title: 'Subscriptions',
		},
	},
	{
		path: '/payments/subscriptions',
		name: 'subscriptions',
		component: () => import(/* webpackChunkName: "payment" */'../views/SubscriptionOverview.vue'),
		meta: {
			title: 'Subscriptions',
		},
	},

	// {
	// 	path: '/profile_overview_dashboard/:user_id',
	// 	name: 'profile_overview',
	// 	component: ProfileOverviewDashboard,
	// 	meta: {
	// 		title: 'Member - Profile Overview',
	// 	},
	// },

	{
		path: '/profile_report/:user_id',
		name: 'profile_report',
		component: () => import('../views/ProfileReport.vue'),
		meta: {
			min_level: 'member',
			title: 'Profile Reports',
		},
	},

	{
		path: '/register',
		name: 'register',
		component: () => import('../views/Register.vue'),
		meta: {
			title: 'Register',
			layout: 'auth',
		},
	},

	{
		path: '/reports_overview',
		name: 'reports_overview',
		component: () => import(/* webpackChunkName: "admin" */'../views/ReportsOverview.vue'),
		meta: {
			min_level: 'admin',
			title: 'Reports Overview',
		},
	},

	{
		path: '/board_sleep',
		name: 'board_sleep',
		beforeEnter() {
			window.open('https://sleep.iamconnected.com', '_self');
		},
	},
	{
		path: '/board_meditation',
		name: 'board_meditation',
		beforeEnter() {
			window.open('https://meditation.iamconnected.com', '_self');
		},
	},
	// {
	// 	path: '/board_meditation/muse',
	// 	name: 'board_meditation_muse',
	// 	beforeEnter() {
	// 		window.open('https://meditation.iamconnected.com/muse', '_self');
	// 	},
	// },
	{
		path: '/email_members',
		name: 'email_members',
		component: () => import(/* webpackChunkName: "admin" */'../views/EmailMembers.vue'),
		meta: {
			min_level: 'admin',
			title: 'Email Members',
		},
	},
	// {
	// 	path: '/fetch_api_data',
	// 	name: 'fetch_api_data',
	// 	beforeEnter() {
	// 		window.open(process.env.VUE_APP_API_URL + 'fetch_api_data', '_blank');
	// 	},
	// },
	// {
	// 	path: '/forum2',
	// 	name: 'forum',
	// 	beforeEnter() {
	// 		window.open('https://forum.iamconnected.com', '_self');
	// 	},
	// },
	// {
	// 	path: '/forum/categories/:slug',
	// 	name: 'forum_categories',
	// 	beforeEnter(vars) {
	// 		window.open('https://forum.iamconnected.com/categories/' + vars.params.slug, '_self');
	// 	},
	// },
	{
		path: '/login',
		name: 'login',
		component: () => import('../views/Login.vue'),
		meta: {
			title: 'Login',
			layout: 'auth',
		},
	},
	{
		path: '/login/forgot',
		name: 'login_forgot',
		component: () => import('../views/Login.vue'),
		meta: {
			title: 'Login',
			layout: 'auth',
		},
	},
	{
		path: '/business_teams',
		name: 'business_teams',
		component: () => import(/* webpackChunkName: "admin" */'../views/BusinessTeams.vue'),
		meta: {
			min_level: 'admin',
			title: 'Business Teams',
		},
	},
	{
		path: '/members',
		name: 'members',
		component: () => import(/* webpackChunkName: "admin" */'../views/Members.vue'),
		meta: {
			min_level: 'admin',
			title: 'Members',
		},
	},
	{
		path: '/connections',
		name: 'connections',
		component: () => import(/* webpackChunkName: "connections" */'../views/MyConnections.vue'),
		meta: {
			min_level: 'member',
			title: 'Connections',
		},
	},
	{
		path: '/programs',
		name: 'programs',
		component: () => import(/* webpackChunkName: "programs" */'../views/Challenges.vue'),
		meta: {
			min_level: 'member',
			title: 'Programs',
		},
	},
	{
		path: '/programs/archive',
		name: 'ProgramsArchive',
		component: () => import(/* webpackChunkName: "programs" */'@/views/ChallengesArchive.vue'),
		meta: {
			min_level: 'admin',
			title: 'Programs Archive',
		},
	},
	{
		path: '/programs/:challenge_id?',
		name: 'ProgramMembers',
		component: () => import(/* webpackChunkName: "programs" */'../views/Program.vue'),
		meta: {
			min_level: 'member',
			title: 'Program',
		},
	},
	{
		path: '/programs/:challenge_id?/email',
		name: 'ProgramEmail',
		component: () => import(/* webpackChunkName: "programs" */'@/views/ChallengeEmail.vue'),
		meta: {
			min_level: 'admin',
			title: 'Program Email',
		},
	},
	{
		path: '/teams/:team_id',
		name: 'team',
		component: () => import('../views/Teams.vue'),
		meta: {
			min_level: 'coach',
			title: 'Team Members',
		},
	},
	{
		path: '/profile',
		name: 'profile',
		component: () => import(/* webpackChunkName: "bio-testing" */'../views/Profile.vue'),
		meta: {
			min_level: 'member',
			title: 'My Profile',
		},
	},
	{
		path: '/member/:user_id',
		name: 'member_profile',
		component: () => import(/* webpackChunkName: "member-profile" */'../views/UserProfile.vue'),
		meta: {
			min_level: 'member',
			title: 'Member Profile',
		},
	},
	{
		path: '/chatbox/:recipientId?',
		name: 'chatbox',
		component: () => import(/* webpackChunkName: "chatbox" */'../views/Chatbox.vue'),
		meta: {
			title: 'Messages',
		},
	},
	{
		path: '/processing-request/:notificationId',
		name: 'processing_request_landing',
		component: () => import('../views/ProcessingRequestLanding.vue'),
		meta: {
			min_level: 'member',
			title: 'Processing Request',
		},
	},
	{
		path: '/sandpit',
		name: 'sandpit',
		component: () => import(/* webpackChunkName: "admin" */'../views/Sandpit.vue'),
		meta: {
			min_level: 'admin',
			title: 'Sandpit',
		},
	},

	{
		path: '/community',
		name: 'community',
		component: () => import(/* webpackChunkName: "community" */'../views/Community.vue'),
		meta: {
			min_level: 'member',
			title: 'Community',
		},
	},

	{
		path: '*',
		name: '404',
		component: () => import(/* webpackChunkName: "error" */'../views/Error404.vue'),
	},
];

const router = new VueRouter({
	mode: 'history',
	routes,
});

export default router;
